var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
(function (factory) {
    if (typeof module === "object" && typeof module.exports === "object") {
        var v = factory(require, exports);
        if (v !== undefined) module.exports = v;
    }
    else if (typeof define === "function" && define.amd) {
        define('score_ccf/XPerience/Actions/ContactVisitWithTheProfileCard',["require", "exports", "jquery", "loglevel", "./../XPActionBase"], factory);
    }
})(function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var $ = require("jquery");
    var log = require("loglevel");
    var XPActionBase_1 = require("./../XPActionBase");
    var ContactVisitWithTheProfileCard = /** @class */ (function (_super) {
        __extends(ContactVisitWithTheProfileCard, _super);
        function ContactVisitWithTheProfileCard(attributes) {
            var _this = _super.call(this, attributes) || this;
            _this.apiEndpoint = "/scoreui/concatvisitwith/{cardId}";
            return _this;
        }
        ContactVisitWithTheProfileCard.prototype.execute = function (component) {
            var _this = this;
            var url = this.apiEndpoint.replace("{cardId}", this.ProfileCardId);
            $.post(url, function (response) {
                if (response.error) {
                    throw new Error(response.error);
                }
                if (response.success) {
                    log.debug("Profile card associated: " + _this.ProfileCardId);
                }
            }, "json");
        };
        return ContactVisitWithTheProfileCard;
    }(XPActionBase_1.XPActionBase));
    exports.default = ContactVisitWithTheProfileCard;
});
//# sourceMappingURL=ContactVisitWithTheProfileCard.js.map;
